import { getCurrentUserHasCore } from '@wix/da-shared-react/pkg/publicSession';
import { connect, MapStateToProps } from 'react-redux';
import { AppState } from '../../../../types/store';
import { getInstallableModulesInfo } from '../../../selectors/layout';
import { Props } from './AddWidget';

type StateProps = Pick<Props, 'hasCoreMembership' | 'installableModulesInfo'>;
type OwnProps = Omit<Props, keyof StateProps>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  props
) => ({
  hasCoreMembership: getCurrentUserHasCore(state),
  installableModulesInfo: props.installableModules.map(
    ({ moduleName, zone }) => {
      const m = getInstallableModulesInfo(state, props.section, zone) || [];
      return m.find(module => module.moduleName === moduleName);
    }
  ),
});

export default connect(mapStateToProps);
